import { getScenarioActions } from '../actions/getScenarioActions';
import { observer } from 'mobx-react-lite';
import type { DateRange } from 'owa-datetime-utils';
import { dateRangeFooterText } from './DateRangeFooter.locstring.json';
import loc, { format } from 'owa-localize';
import { formatMonthDayYear } from 'owa-datetime';
import { HeaderFooterMessage } from './HeaderFooterMessage';

import * as React from 'react';

export interface DateRangeFooterHeaderProps {
    scenarioId: string;
    dateRange: DateRange;
}

export const DateRangeFooter = observer(function DateRangeFooter(
    props: DateRangeFooterHeaderProps
) {
    // NOTE - This is intended to be a short-lived metric for getting signal
    // on how often Time Panel users hit the load limit (as currently this
    // component is only rendered when limit has been reached in Time Panel).
    // Invoking this datapoint elsewhere would require a new store property
    // and action lifecycle to correctly log this only once per limit-reached
    // rather than noisily on every list re-render when limit is reached, which
    // is not worth the infra cost at this point of time.
    React.useEffect(() => {
        const { handleLoadLimitReached } = getScenarioActions(props.scenarioId);
        handleLoadLimitReached();
    }, []);

    // VSO 56737 Revert check once root cause of null dateRange is understood and fixed
    if (!props.dateRange) {
        return null;
    }

    const dateText = getDateRangeText(props.dateRange);
    return <HeaderFooterMessage message={dateText} />;
});

function getDateRangeText(dateRange: DateRange) {
    return format(
        loc(dateRangeFooterText),
        formatMonthDayYear(dateRange.start),
        formatMonthDayYear(dateRange.end)
    );
}
